import React from "react"
import { Route, Navigate } from "react-router-dom"
import { useAuth } from "../Contexts/AuthContexts"
import { useData } from '../Contexts/DataContext';
import Loading from './Loading'

export default function PrivateRoute({ children }) {
  const provider = useAuth()
  const collector = useData()
  React.useEffect (()=> {
    async function ensureData() {
          await collector.getEventData();
          await collector.getUserCreds();
    }
    ensureData();
  }, []);
  return (
       provider.currentUser ? collector.user != null ? children : 
        <Loading />
       : <Navigate to="/" />
  )
}